module.exports = __webpack_public_path__ + "img/huxing2.c5369457.jpg";